import { render, staticRenderFns } from "./CommentCategorize.vue?vue&type=template&id=02042922&scoped=true&"
import script from "./CommentCategorize.vue?vue&type=script&lang=js&"
export * from "./CommentCategorize.vue?vue&type=script&lang=js&"
import style0 from "./CommentCategorize.vue?vue&type=style&index=0&id=02042922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02042922",
  null
  
)

export default component.exports